<template>
  <div id="memberAnalytics">
    <md-empty-state
      class="md-primary"
      md-icon="query_stats"
      md-label="Nothing in Done"
      md-description="Anything you mark done will be safely stored here.">
    </md-empty-state>
  </div>
</template>

<script>
export default {
  name: 'MemberAnalytics'
}
</script>
